import { FormattedMessage, useIntl } from '@zenbusiness/application-commons-intl';
import ContentHeader from '@zenbusiness/zui/ContentHeader';
import Text from '@zenbusiness/zui/Text';

import { useDashboardPath } from '#client/hooks/useDashboardPath';

import * as Styled from './TaxAdviceCard.styles';

const TaxAdviceCard = () => {
  const { formatMessage: fm } = useIntl();
  const dashboardPath = useDashboardPath();

  const destination = `${dashboardPath}/money/tax-services`;

  return (
    <Styled.Root>
      <Styled.Image
        alt={fm({ id: 'dashboard.carousel.card.taxAdvice.imageAlt' })}
        src="/s2/raster/accountant-desk-working.jpg"
      />
      <Styled.CardContent>
        <ContentHeader
          title={<Text size="md" weight="medium" color="primary"><FormattedMessage id="dashboard.carousel.card.taxAdvice.title" /></Text>}
          subtitle={<Text size="sm" weight="regular" color="secondary"><FormattedMessage id="dashboard.carousel.card.taxAdvice.subTitle" /></Text>}
        >
          <Styled.CardButton
            clickstreamProps={{
              elementName: 'carousel_link',
              elementText: 'tax_advice',
              destination
            }}
            color="secondary"
            size="sm"
            to={destination}
          >
            <FormattedMessage id="dashboard.carousel.card.taxAdvice.button" />
          </Styled.CardButton>
        </ContentHeader>
      </Styled.CardContent>

    </Styled.Root>
  );
};

export default TaxAdviceCard;
